import i18n, { TranslateArg } from 'helpers/i18n';
import messages from 'components/Password/messages';
import { parseAPIErrorsNoKeys } from 'components/ErrorModal/utils';

export type PasswordApiErrors =
  string | Record<string, string[] | string> | undefined | null;

export function parsePasswordApiErrors(errors: PasswordApiErrors): string {
  if (!errors) {
    return '';
  }

  if (typeof errors === 'string') {
    return errors;
  }

  return parseAPIErrorsNoKeys(errors).join('. ');
}

const POLICY_CODE_MESSAGES: Record<string, TranslateArg> = {
  common_password: messages.commonPassword,
  password_reused: messages.recentlyUsedPassword,
  requirements_not_met: messages.requirementsNotMet,
  password_not_accepted: messages.passwordNotAccepted
};

const NON_POLICY_CODES = [
  'stale_credentials',
  'password_not_expired',
  'missing_params',
  'same_as_expired_password',
  'invalid_password',
  'unexpected_error'
];

export function describePasswordPolicyCode(
  code: string | undefined | null
): string | null {
  if (!code || NON_POLICY_CODES.includes(code)) {
    return null;
  }

  const message = POLICY_CODE_MESSAGES[code];

  return i18n.ft(message ?? messages.passwordNotAccepted);
}
